const U = (id) => (id.startsWith("http") ? id : `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80`);

const POOLS = {
  singers: ["1731461298455-088aae689fca", "1543510616-a4025b9c1434", "1606946370568-27bb6a2d1b90", "1538819137474-ffa0ee381af6", "1606945071635-51dd144bedbc"],
  drummers: ["1663071171258-5ce1e0131006", "1619065513120-ad804c3f5e22", "1593659238861-ee6e27fb9855", "1543772429-aa0652189bf7", "1663071777983-6b8468bca38b"],
  guitarists: ["1632164815269-fb4cd5ced785", "1589692877746-c88e891eb3cd", "1765294661293-7aacdafed0b5", "1684095798843-8c6281c08ffc", "1525201548942-d8732f6617a0"],
  pianists: ["1763480521691-7a2bf96956ef", "https://images.pexels.com/photos/6647449/pexels-photo-6647449.jpeg?auto=compress&cs=tinysrgb&w=1400", "1665213275977-c73ac544d531", "1552422535-c45813c61732", "1598281944085-dc202b6a2b6e", "1632129389102-893933d70693"],
};

export function lessonImage(instrumentId, lessonNumber, courseId) {
  const pool = POOLS[instrumentId] || POOLS.singers;
  const i = (lessonNumber - 1 + (courseId === "mastery" ? 2 : 0)) % pool.length;
  return U(pool[i]);
}
